import { memo } from "react";
import { WARNING_SINGLE_WAVE_POSTCODES_TITLE } from "../../../consts/strings";
import { Modal } from "../Modal";
import { SingleWavesPostcodesAction } from "./SingleWavesPostcodesAction";
import { SingleWavesPostcodesContent } from "./SingleWavesPostcodesContent";

export const SingleWavesPostcodesModal = memo(
  ({ open, onClose, onContinue, postcodes }) => {
    return (
      <Modal
        open={open}
        onClose={onClose}
        title={WARNING_SINGLE_WAVE_POSTCODES_TITLE}
        content={<SingleWavesPostcodesContent postcodes={postcodes} />}
        actions={
          <SingleWavesPostcodesAction
            onCancel={onClose}
            onContinue={onContinue}
          />
        }
        maxWidth={"sm"}
      />
    );
  }
);
